import { EmbeddedSprite } from './EmbeddedSprite';

export class PlayerAvatar extends EmbeddedSprite {
    constructor(url: string, width: number, height: number) {
        super({ url: url, width: width, height: height });
    }
}
